/* eslint-env browser */
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import LoginMenuContainer from './containers/LoginMenuContainer';

declare global {
  interface Window {
    userContext: AU.IUserContext;
    appLang: string;
    IMPERSONATE_EDUCATIONS: number[];
    IMPERSONATE_FACULTIES: number[];
    IMPERSONATE_CAMPUSES: number[];
    studentCardEnabled: boolean;
    ACTIVATE_URI: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    iFrameResize: any;
    dataLayer: Record<string, unknown>[];
    admissionAreaCodesWithQuota2: number[];
    quota2UniTestPath: string;
    facultyId: number;
  }
}

const rootElement = document.querySelector('.app-minansoegning-container');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);
root.render(
  <StrictMode>
    <LoginMenuContainer />
  </StrictMode>,
);
